import React from 'react';
import 'react-table/react-table.css';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Pagination from 'react-js-pagination';
import $ from 'jquery';
import { LinearProgress } from 'react-md';
import '../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import ViewModal from '../cpdrecord/_modal/view';
import Loader from '../_components/loader';
import { Urls } from '../network/config';
import { connect } from 'react-redux';
import { removeData } from '../store/action';
import '../components/style.css';
import { AdminUrls } from '../network/config';

const moment = require('moment');
const downloadFile_Url = AdminUrls.COMMON.COURSEFILEDOWNLOAD;

class CPDGO extends React.Component {
  constructor() {
    super();
    this.handlePaginationFilter = this.handlePaginationFilter.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
    this.viewFileHandle = this.viewFileHandle.bind(this);

    this.state = {
      course_name: '',
      location_name: '',
      host: '',
      start_date: '',
      sort: {
        column: 'StartDate',
        direction: 'desc',
      },
      approved_cpd_records: [],
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      listViewModalShown: false,
      listViewDataCourseName: '',
      listViewDatastartDate: '',
      listViewDatacourseLocation: '',
      listViewDatacourseType: '',
      listViewDatahost: '',
      listViewDatacpdFormat: '',
      listViewDatavenue: '',
      listViewDatatrainer: '',
      listViewDatacourseDescription: '',
      listViewDatahowToBook: '',
      listViewDatasurveyLink: '',
      listViewDatacourseFilePathItems: [],
      mainLoading: false,
      emptyDivMsg:
        'There is no data to show in the grid for the current selection.\n' +
        "If you can't find what you are looking for? Check out our online offerings in CPDgo.",
    };
  }

  handleInputChange(name, value) {
    let newValue = value;
    if (name === 'start_date') {
      var mydate = moment(value, 'DD/MM/YYYY');
      let newDate = new Date(moment(mydate).format('MM/DD/YYYY'));
      newValue = newDate.toISOString();
      this.setState({
        start_date_iso: newValue,
      });
    }
    this.setState({
      [name]: value,
    });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.makeHttpRequestWithPage(pageNumber);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        mainLoading: false,
      });
    }, 1000);

    $('.datepicker').datepicker();
    this.makeHttpRequestWithPage(1);
  }

  makeHttpRequestWithPage(pageNumber, column, direction) {
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;

    this.setState({
      mainLoading: true,
    });

    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }

    reverse = reverse === 'asc' ? false : true;

    let self = this;
    axios
      .get(Urls.CPDgo_URL, {
        params: {
          CourseName: this.state.course_name,
          HostName: this.state.host,
          LocationName: this.state.location_name,
          StartDate: this.state.start_date,
          reverse: reverse,
          sortBy: sortBy,
          page: pageNumber,
          pageSize: this.state.per_page,
        },
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('access_token'),
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          approved_cpd_records: data.Items,
          totalPages: data.TotalPages,
          activePage: data.Page,
          totalCount: data.TotalCount,
          mainLoading: false,
        });
      })
      .catch(function (error) {
        if (error) {
          if (error.response) {
            if (error.response.status === 401) {
              self.setState({
                unauthorized: true,
                mainLoading: false,
              });
              localStorage.setItem('failureMessage', 'Login Expired');
              self.props.signOut();
            }
          }
        }
      });
  }

  handlePaginationFilter(event) {
    let value = event.target.value;
    this.setState({
      per_page: value,
      mainLoading: true,
    });
    setTimeout(() => {
      this.makeHttpRequestWithPage(1);
    }, 1000);
  }

  clearSearchFilters() {
    this.setState({
      course_name: '',
      location_name: '',
      host: '',
      start_date: '',
      sort: {
        column: 'StartDate',
        direction: 'desc',
      },
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
    });
    $('.datepicker').datepicker();

    this.setState({
      mainLoading: true,
    });

    setTimeout(() => {
      this.makeHttpRequestWithPage(1);
    }, 1000);
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.makeHttpRequestWithPage(1, column, direction);
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  handleDownloadFile(fileData) {
    if (
      fileData &&
      fileData?.ModifiedFileName.toUpperCase() !== 'NO FILE UPLOADED'
    ) {
      var downloadPath =
        downloadFile_Url + '?name=' + fileData?.ModifiedFileName;
      window.open(downloadPath, '_blank', '');
    }
  }

  viewFileHandle(row, userType) {
    if (row && row.ModifiedFileName) {
      if (userType && userType === '1') {
        //userVideoInfo(config.COMMON.VIDEOUPDATE, row, $http);
      }
      //window.open(config.COMMON.VIDEOFILE + row.ModifiedFileName);
      window.open(
        `${process.env.PUBLIC_URL}/video/CPDVideo.html?CId=${row.CourseId}&VidComp=${row?.IsVideoCompleted}&VidStringFormat=${row?.VideoCompletedDateStringFormat}`
      );
    }
  }

  openModalWithItem(
    courseName,
    startDate,
    courseLocation,
    courseType,
    host,
    cpdFormat,
    venue,
    trainer,
    courseDescription,
    howToBook,
    courseFilePathItems,
    surveyLink
  ) {
    this.setState({
      listViewDataCourseName: courseName,
      listViewDatastartDate: startDate ? startDate : 'na',
      listViewDatacourseLocation: courseLocation ? courseLocation : 'na',
      listViewDatacourseType: courseType ? courseType : 'na',
      listViewDatahost: host ? host : 'na',
      listViewDatacpdFormat: cpdFormat ? cpdFormat : 'na',
      listViewDatavenue: venue ? venue : 'na',
      listViewDatatrainer: trainer ? trainer : 'na',
      listViewDatacourseDescription: courseDescription
        ? courseDescription
        : 'na',
      listViewModalShown: true,
      listViewDatahowToBook: howToBook,
      listViewDatacourseFilePathItems: courseFilePathItems,
      listViewDatasurveyLink: surveyLink,
    });
  }

  downloadExcel() {
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(Urls.FACE_TO_FACE_Excel_Download_URL, {
      responseType: 'blob',
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization: 'bearer ' + localStorage.getItem('access_token'),
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'ATICPD.xlsx');
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch(console.log);
  }

  render() {
    if (this.state.unauthorized) {
      return <Redirect to="/" />;
    }

    let listViewModalShownClose = () =>
      this.setState({ listViewModalShown: false });
    let approved_cpd_records;

    if (this.state.approved_cpd_records !== null) {
      approved_cpd_records = this.state.approved_cpd_records.map(
        (cpd_record, index) => (
          <tr key={index}>
            <td>{cpd_record.CourseName}</td>
            <td>{cpd_record.LocationName}</td>
            <td>
              {cpd_record.Duration > 0
                ? cpd_record.Duration + 'h'
                : cpd_record.Minutes + 'm'}
            </td>
            <td>{cpd_record.HostName}</td>
            <td>{cpd_record.CPDTypeName}</td>
            <td>{cpd_record.Trainer}</td>
            <td>
              {cpd_record.StartDate
                ? moment(cpd_record.StartDate).format('ll')
                : 'na'}
            </td>
            <td className="text-center">
              <a
                data-item={cpd_record}
                onClick={() => {
                  this.openModalWithItem(
                    cpd_record.CourseName,
                    cpd_record.StartDate
                      ? moment(cpd_record.StartDate).format('ll')
                      : 'na',
                    cpd_record.LocationName,
                    cpd_record.CPDTypeName,
                    cpd_record.HostName,
                    cpd_record.CPDFormatName,
                    cpd_record.Venue,
                    cpd_record.Trainer,
                    cpd_record.CourseDescription,
                    cpd_record.HowToBook,
                    cpd_record.CourseFilePathItems,
                    cpd_record.SurveyLink
                  );
                }}
                style={{ fontSize: '20px', cursor: 'pointer', color: 'black' }}
              >
                <i className="fa fa fa-eye"> </i>
              </a>
            </td>
          </tr>
        )
      );
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div className="panel panel-default">
          <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
            <i
              className="fa fa-filter "
              title=""
              tooltip=""
              data-original-title="Search"
            >
              {' '}
              Search
            </i>
          </div>
          <form className="shadow">
            <div className="layout-gt-sm-row">
              <div style={{ padding: '1rem 1rem' }}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group member-forms">
                      <label>Course name</label>
                      <input
                        type="Course name"
                        className="form-control"
                        id="Course name"
                        onChange={(e) =>
                          this.setState({ course_name: e.target.value })
                        }
                        value={this.state.course_name}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group member-forms">
                      <label>Location name</label>

                      <input
                        type="Location name"
                        className="form-control"
                        id="location_name"
                        value={this.state.location_name}
                        onChange={(e) =>
                          this.setState({ location_name: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group member-forms">
                      <label>Host</label>
                      <input
                        type="host"
                        className="form-control"
                        id="host"
                        value={this.state.host}
                        onChange={(e) =>
                          this.setState({ host: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group date admin-forms">
                      <label>Enter Start Date</label>

                      <input
                        type="date"
                        placeholder=""
                        className="form-control"
                        value={this.state.start_date}
                        onChange={(e) =>
                          this.setState({ start_date: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <button
                    className="btn btn-primary"
                    style={{ marginRight: '10px' }}
                    onClick={() => this.makeHttpRequestWithPage(1)}
                    onKeyPress={() => this.makeHttpRequestWithPage(1)}
                    type="Submit"
                  >
                    <span className="glyphicon glyphicon-search"> </span> Search
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => this.clearSearchFilters()}
                  >
                    <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="row">
          <div className="gridTopButtons">
            <button
              type="button"
              onClick={() => window.print()}
              className="btn btn-danger btn-circle btn-lg ng-scope"
              tooltip=""
            >
              <i className="fa fa-print"> </i>
            </button>
            <button
              type="button"
              onClick={() => {
                this.downloadExcel();
              }}
              style={{ marginLeft: '10px', lineHeight: '28px' }}
              className="btn btn-success btn-circle btn-lg "
            >
              <i className="fa fa-file-excel-o"> </i>
            </button>
          </div>
          <div className="gridTopDropdown">
            {' '}
            Show
            <select
              className="input-sm ng-pristine ng-untouched ng-valid ng-not-empty"
              onChange={(e) => this.handlePaginationFilter(e)}
            >
              <option label="10" value="10" defaultValue>
                10
              </option>
              <option label="20" value="20">
                20
              </option>
              <option label="30" value="30">
                30
              </option>
            </select>
            entries
          </div>
        </div>
        <div className="col">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th role="button" onClick={this.onSort('CourseName')}>
                  Course Name <i className={this.setArrow('CourseName')}> </i>
                </th>
                <th role="button" onClick={this.onSort('LocationName')}>
                  Location<i className={this.setArrow('LocationName')}> </i>
                </th>
                <th role="button" onClick={this.onSort('Duration')}>
                  CPD Hours<i className={this.setArrow('Duration')}> </i>
                </th>
                <th role="button" onClick={this.onSort('HostName')}>
                  Host<i className={this.setArrow('HostName')}> </i>
                </th>
                <th role="button" onClick={this.onSort('CPDTypeName')}>
                  Type<i className={this.setArrow('CPDTypeName')}> </i>
                </th>
                <th role="button" onClick={this.onSort('Trainer')}>
                  Trainer<i className={this.setArrow('Trainer')}> </i>
                </th>
                <th role="button" onClick={this.onSort('StartDate')}>
                  Start Date<i className={this.setArrow('StartDate')}> </i>
                </th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>{approved_cpd_records}</tbody>
          </table>
          {approved_cpd_records.length > 0 ? '' : this.state.emptyDivMsg}
          <div>
            <Pagination
              prevPageText="Previous"
              nextPageText="Next"
              firstPageText="First"
              lastPageText="Last"
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.per_page}
              totalItemsCount={this.state.totalCount}
              onChange={this.handlePageChange}
            />
          </div>
        </div>
        <ViewModal
          show={this.state.listViewModalShown}
          data={this.state}
          onHide={listViewModalShownClose}
          coursename={this.state.listViewDataCourseName}
          startdate={this.state.listViewDatastartDate}
          courselocation={this.state.listViewDatacourseLocation}
          coursetype={this.state.listViewDatacourseType}
          host={this.state.listViewDatahost}
          cpdformat={this.state.listViewDatacpdFormat}
          venue={this.state.listViewDatavenue}
          trainer={this.state.listViewDatatrainer}
          description={this.state.listViewDatacourseDescription}
          howToBook={this.state.listViewDatahowToBook}
          surveyLink={this.state.listViewDatasurveyLink}
          handleDownloadFile={this.handleDownloadFile}
          viewFileHandle={this.viewFileHandle}
          courseFilePathItems={this.state.listViewDatacourseFilePathItems}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(null, mapDispatchToProps)(CPDGO);
